import { PropertyMetadata } from "./DynamicProperty";

export interface DamageMetadataResponse {
  metadata: PropertyMetadata[];
  atConnectionFieldIndicator: string;
  c1CodeFieldIndicator: string;
  c2CodeFieldIndicator: string;
  distanceFieldIndicator: string;
  mainCodeFieldIndicator: string;
  positionFromFieldIndicator: string;
  positionToFieldIndicator: string;
  quantification1FieldIndicator: string;
  quantification2FieldIndicator: string;
  trackDamageFieldIndicator: string;
  videoPositionFieldIndicator: string;
}

export const emptyDamageMetadata: DamageMetadataResponse = {
  metadata: [],
  atConnectionFieldIndicator: "",
  c1CodeFieldIndicator: "",
  c2CodeFieldIndicator: "",
  distanceFieldIndicator: "",
  mainCodeFieldIndicator: "",
  positionFromFieldIndicator: "",
  positionToFieldIndicator: "",
  quantification1FieldIndicator: "",
  quantification2FieldIndicator: "",
  trackDamageFieldIndicator: "",
  videoPositionFieldIndicator: "",
};
